export default __webpack_public_path__ + "static/media/discord.1358eab4.png";